export class Search {
	static readonly type = '[fireInsuranceBrokerageSearch] search';
	constructor(public searchTerm: string) {}
}
